import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "incident-banner" }
const _hoisted_2 = { class: "incident-banner__row incident-banner__row--doctors" }
const _hoisted_3 = { class: "incident-banner__label" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "incident-banner__row incident-banner__row--patients" }
const _hoisted_6 = { class: "incident-banner__label" }
const _hoisted_7 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.dict.doctors.label), 1),
      _createTextVNode(" " + _toDisplayString(_ctx.dict.doctors.info) + " ", 1),
      _createElementVNode("a", {
        class: "incident-banner__link",
        href: _ctx.URI_DOCTORS_INCIDENT_INFO,
        target: "_blank",
        rel: "noopener noreferrer"
      }, _toDisplayString(_ctx.dict.doctors.action), 9, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.dict.patients.label), 1),
      _createTextVNode(" " + _toDisplayString(_ctx.dict.patients.info) + " ", 1),
      _createElementVNode("a", {
        class: "incident-banner__link",
        href: _ctx.URI_PATIENTS_INCIDENT_INFO,
        target: "_blank",
        rel: "noopener noreferrer"
      }, _toDisplayString(_ctx.dict.patients.action), 9, _hoisted_7)
    ])
  ]))
}